import Smartphones from 'Events/Events/views/SpecificEventsView/containers/Smartphones'
import Tablets from 'Events/Events/views/SpecificEventsView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const SpecificEventsView = getCurrentDeviceView(Smartphones, Tablets)

export default SpecificEventsView
